import {Injectable} from '@angular/core';
import {Observable, Subject, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EventsManagerService {

  private subscriptions: { [key: string]: Subscription } = {};
  private events: { [key: string]: Observable<DataForm> } = {};

  private readonly fooSubject: Subject<any> = new Subject<any>();


  /**
   * Emitir un evento
   *
   */
  publish(data: DataForm) {
    this.fooSubject.next(data);
  }


  /**
   * Escuchar un evento
   *
   */
  observe(name: string): Observable<DataForm> | null {

    if (this.events[name]) {
      return null;
    }

    this.events[name] = this.fooSubject.pipe(filter(ev => ev.name === name));
    return this.events[name];
  }


  /**
   * Guarda las subscripciones
   *
   */
  addSubscriptions(subscriptions: Subscription[]) {
    subscriptions.forEach((subscription, index) => {
      const key = `subscription_${Date.now()}_${index}`;
      this.subscriptions[key] = subscription;
    });
  }


  /**
   * Cancela una subscripcion
   *
   */
  unsubscribe(name: string) {

    if (!this.subscriptions[name]) {
      return;
    }

    this.subscriptions[name].unsubscribe();

    delete this.subscriptions[name];
    delete this.events[name];
  }


  /**
   * Cancela todas las subscripciones
   *
   */
  unsubscribeAll() {
    Object.values(this.subscriptions)?.forEach((sub) => sub?.unsubscribe());

    this.subscriptions = {};
    this.events = {};
  }

}

export interface DataForm {
  name: string;
  data?: any;
}
